import axios from "axios";
export default {
  methods: {
    /**
     * Retorna todos os estados do Brasil
     * @return {Array<Object>}
     */
    getEstados() {
      return axios.get(
        this.CriarUrl({
          resource: "dashboard/estados"
        })
      );
    },
    /**
     * Retorna os estados de uma determinada região do Brasil
     * @return {Array<Object>}
     */
    getEstadosRegiao(siglaRegiao) {
      return axios.get(
        this.CriarUrl({
          resource: "dashboard/estados/" + siglaRegiao
        })
      );
    },
    /**
     * Retorna todas as regiões do Brasil
     * @return {Array<Object>}
     */
    getRegioes() {
      return axios.get(
        this.CriarUrl({
          resource: "dashboard/regioes"
        })
      );
    },
    /**
     * Retorna as informações dos gráficos de tipo rede, tipo vinculo e tipo prestador
     * @param { Object } params
     * @returns { Array<Object> }
     */
    getQuantidades(params) {
      return axios.get(
        this.CriarUrl({
          resource: "dashboard/quantidades",
          params
        })
      );
    },

    /**
     * Retorna os prestadores por região, serve para popular as informações do mapa
     * @returns { Array<Object> }
     */
    getTotalRegiao() {
      return axios.get(
        this.CriarUrl({
          resource: `dashboard/totalRegiao`
        })
      );
    }
  }
};
